import React from 'react'

import { SIM_JOURNEY_TYPES } from '@smarty-nx/code-utils'
import { Plan } from '@smarty-nx/data'
import { colors } from '@smarty-nx/ds'
import {
  DATA_LAYER_EVENTS,
  CHECKOUT_TYPES,
  TRACKING_CATEGORIES,
} from '@smarty-nx/tracking'

import { planDetailsContent } from './content'
import planClasses from './plan-details.module.scss'
import ColorButton from '../../components/ColorButton'
import DiscountCard from '../../components/DiscountCard'
import {
  HowItWorksSteps,
  HowItWorksTimeline,
} from '../../components/HowItWorksTimeline'
import {
  CenteredButton,
  FullWidthContainer,
  HideOnMobile,
  HideTabletUpwards,
  SiteContainer,
} from '../../components/shared'
import spacerClasses from '../../components/styles/spacer.module.scss'
import WhySmartyPlans from '../../components/WhySmarty'
import AllPlans from '../../modular-system/AllPlans'
import CoverageBlock from '../../modular-system/CoverageBlock'
import Quote from '../../modular-system/Quote'
import UnlimitedBanner from '../../modular-system/UnlimitedBanner'
import { triggerProductEvent } from '../../utils/dataLayer'
import { buildAssetsProductsProps } from '../../utils/dmpgAttributes'
import { PlanMeta } from '../../utils/plans.types'

export const renderAllPlansInclude = (plan: PlanMeta) => (
  <AllPlans currentPlan={plan} hasIcon />
)

export const renderCoverage = () => (
  <FullWidthContainer
    background={colors['UI/DarkGrey']}
    data-testid="coverage-section"
  >
    <SiteContainer>
      <CoverageBlock />
    </SiteContainer>
  </FullWidthContainer>
)

export const renderDiscountCard = () => (
  <div className={spacerClasses.spacerHalf}>
    <FullWidthContainer
      background={colors['UI/DarkGrey']}
      className={planClasses.discountCardContainer}
    >
      <SiteContainer>
        <DiscountCard />
      </SiteContainer>
    </FullWidthContainer>
  </div>
)

export const renderTrackedCTA = (
  plan: PlanMeta,
  priceData: Plan,
  category: string,
  name: string
) => (
  <CenteredButton>
    <ColorButton
      href={`/order/${plan.slug}`}
      onClick={() => {
        triggerProductEvent(
          DATA_LAYER_EVENTS.ADD_TO_CART,
          buildAssetsProductsProps({ planMeta: plan, priceData }).products[0],
          CHECKOUT_TYPES.REGULAR,
          SIM_JOURNEY_TYPES.ONLINE_SIM_ORDER_JOURNEY
        )
      }}
      color={plan.color}
      wide
      data-item-category={category}
      data-item-name={name}
    >
      {planDetailsContent.ctaOrderSim(plan.name ?? '')}
    </ColorButton>
  </CenteredButton>
)

export const renderQuote = () => (
  <SiteContainer className={planClasses.quoteSiteContainer}>
    <Quote
      text={planDetailsContent.quoteText}
      source={planDetailsContent.quoteSource}
      className={planClasses.quote}
    />
  </SiteContainer>
)

export const renderTimeline = (plan: PlanMeta, priceData: Plan) => (
  <div data-testid="how-it-works-section">
    <HideTabletUpwards>
      <HowItWorksTimeline plan={plan} />
    </HideTabletUpwards>
    <HideOnMobile>
      <HowItWorksSteps plan={plan} />
    </HideOnMobile>
    {renderTrackedCTA(
      plan,
      priceData,
      TRACKING_CATEGORIES.NAVIGATION,
      planDetailsContent.ctaDataItemName
    )}
  </div>
)

export const renderUnlimitedBanner = () => (
  <div data-testid="unlimited-banner" className={spacerClasses.spacerQuarter}>
    <UnlimitedBanner />
  </div>
)

export const renderWhySmarty = () => (
  <div className={spacerClasses.spacer2x}>
    <SiteContainer>
      <WhySmartyPlans darkTheme />
    </SiteContainer>
  </div>
)
